import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import AutoController from "./AutoController";
import ViewController from "./ViewController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('invoice', {
                abstract: true,
                url:'/invoice'
            })

            .state('invoice.auto', {
                url: '/auto',
                template: require('./Auto.html'),
                controller: AutoController,
                controllerAs: 'vm',
                data: {title: 'Auto Debit Invoices'}
            })
            .state('invoice.view', {
                url: '/view/:invoiceGuid',
                template: require('./View.html'),
                controller: ViewController,
                controllerAs: 'vm',
                data: {title: 'View Invoice'}
            })



    }
}

export default angular.module('app.invoice', [])
    .config(Routes)
    .name;
